var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("Workflow state from "),_c('b',[_vm._v(_vm._s(_vm.custom_id))]),_vm._v(" has been changed to "),_c('b',[_vm._v(_vm._s(_vm.value.event.payload.workflow.state))])])
}
var staticRenderFns = []

export { render, staticRenderFns }